export function getUrlIncluding(
  allUrls: string[],
  paths: string[],
  excludePaths?: string[]
): string | null {
  const url = allUrls.find(url => {
    return (
      paths.every(path => url.includes(path)) &&
      (!excludePaths || excludePaths.every(path => !url.includes(path)))
    );
  });
  if (url) {
    const parts = url.split("||");
    const extracted = parts.length > 1 ? parts[1]?.trim() : undefined;
    return extracted || null;
  }
  return null;
}

export function removeEndingStartingWith(
  url: string | null,
  startingString: string
): string {
  if (!url) return "";
  const index = url.indexOf(startingString);
  if (index !== -1) {
    return url.substring(0, index);
  }
  return url;
}

export function hasPermission(
  userPermissions: string[] | Record<string, boolean> | null | undefined,
  requiredPermission: string
): boolean {
  if (!userPermissions) return false;
  if (Array.isArray(userPermissions)) {
    return userPermissions.some(
      p => p === requiredPermission || p.startsWith(`${requiredPermission}.`)
    );
  }
  return Boolean(userPermissions[requiredPermission]);
}
